"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Transformator = /** @class */ (function () {
    function Transformator() {
    }
    return Transformator;
}());
exports.Transformator = Transformator;
//# sourceMappingURL=transformator.js.map